import React, { useState, useEffect } from "react";
import { CSVLink, CSVDownload } from "react-csv";
import { DateTime } from "luxon";

const ExportCSV = ({
  fields,
  datas,
  exportOptions = {
    excludedFields: [],
    arrayFields: [],
    objectFields: {},
  },
}) => {
  const [launch, setLaunch] = useState(false);

  var { excludedFields, arrayFields, objectFields } = exportOptions;
  arrayFields = arrayFields || [];
  objectFields = objectFields || [];
  function formatToCsv() {
    setLaunch(false);
    var dateFrom = DateTime.local().toFormat("dd-MM-yyyy");
    var fieldsFiltered = fields.filter((f) => !excludedFields.includes(f.name));

    var fieldsFormat = fieldsFiltered.map((f) => f.name);
    var csvData = [fieldsFormat];
    var filename = "EXPORT_" + dateFrom;

    datas.forEach((data) => {
      var entry = [];
      fields.forEach((field) => {
        if (!excludedFields.includes(field.name)) {
          var entryData = "";
          if (arrayFields[field.path]) {
            data[field.path].forEach((subEntryData) => {
              arrayFields[field.path].dataIndexes.forEach((ind) => {
                entryData += subEntryData[ind] + " ";
              });
              entryData += "\n";
            });
          } else if (objectFields[field.path]) {
            objectFields[field.path].dataIndexes.forEach((ind) => {
              entryData += data[field.path][ind] + " ";
            });
          } else {
            entryData = data[field.path];
          }
          entry.push(entryData);
        }
      });
      csvData.push(entry);
    });

    console.log("csvData", csvData);
    setLaunch({ data: csvData, filename });
  }

  return (
    <div className="d-center flex-row">
      <button className="btn btn-primary" onClick={formatToCsv}>
        Exporter en CSV
      </button>

      {launch && (
        <CSVLink
          data={launch.data}
          separator={";"}
          enclosingCharacter={`"`}
          filename={launch.filename + ".csv"}
          onClick={() => setLaunch(false)}
          className="btn btn-link"
        >
          Télécharger
        </CSVLink>
      )}
    </div>
  );
};

export default ExportCSV;
